import React from 'react';
import { CTA } from './CTAButton';

interface SearchButtonProps {
  onSearchClick: (() => void) | null;
  onMobileSearchClick: (() => void) | null;
  cta: CTA | null;
  isSearchActive: boolean;
}

const SearchButton: React.FC<SearchButtonProps> = ({
  onSearchClick,
  onMobileSearchClick,
  cta,
  isSearchActive,
}) => {
  if (!onSearchClick) {
    return null;
  }

  const handleMobileClick = (): void =>
    onMobileSearchClick ? onMobileSearchClick() : onSearchClick();

  return (
    <div className="on-search-click h-100">
      <button
        type="button"
        data-id="header-search-btn"
        className="dn db-l bn outline-0 h-100 pa0 bg-transparent"
        onClick={onSearchClick}
      >
        <div className={`b--black-10 h-100${!cta ? ' bl' : ''}`}>
          <div className="bt bw2 b--white h-100">
            <div
              className={`flex items-center pv0 ph3 h-100 bw2 pointer${!cta ? ' bb' : ''} ${
                isSearchActive ? 'b--blue' : 'b--white'
              }`}
            >
              <span className="icon-search dark-gray f3 ph1" />
            </div>
          </div>
        </div>
      </button>
      <button
        type="button"
        className="bn outline-0 dn-l h-100 bg-transparent"
        data-id="header-search-btn-mobile"
        onClick={handleMobileClick}
      >
        <span className="icon-search dark-gray f2 ph3" />
      </button>
    </div>
  );
};

export default SearchButton;
